import React, { FC, useCallback, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { Button, Tooltip, Table } from '@wmgtech/legato'
import { ColumnsType } from '@wmgtech/legato/build/components/Table/types'

import { GpsBadge } from 'components'

import { Label } from 'shared/__gql-types'
import { TTableColumn } from 'shared/types'

import { ArtistsTableData, IArtistTable } from './ArtistTable.props'

import './ArtistTable.scss'

const ArtistTable: FC<IArtistTable> = ({ artistList, labels }) => {
  const getLabel = useCallback((id: string | undefined) => labels.find((item: Label) => item.id === id), [labels])

  const artistListRows: ArtistsTableData[] = useMemo(
    () =>
      artistList.map((artist) => ({
        id: artist.id,
        name: artist.name ?? '',
        gpsStatus: artist.gps_status ?? '',
        label: getLabel(artist?.label_id ?? '')?.name ?? '',
        editLink: `/admin/artists/${artist.id}`
      })),
    [artistList, getLabel]
  )

  const columns: ColumnsType<TTableColumn>[] = [
    {
      dataIndex: 'name',
      key: 'name',
      title: 'Artist Name',
      sortable: false,
      width: '40%',
      align: 'left'
    },
    {
      dataIndex: 'label',
      key: 'label',
      title: 'Zone',
      sortable: false,
      width: '30%',
      align: 'left'
    },
    {
      dataIndex: 'gpsStatus',
      key: 'gpsStatus',
      title: 'GPS Status',
      sortable: false,
      width: '20%',
      render: (gpsStatus: any) => gpsStatus && <GpsBadge gpsStatus={gpsStatus} coloredBackground />
    },
    {
      dataIndex: '',
      key: 'edit',
      title: 'Edit',
      sortable: false,
      align: 'right',
      width: '10%',
      render: (value: any, artist: any) => (
        <Link to={artist.editLink} className="artist-table-col-edit__link">
          <Tooltip message="Edit Artist" colorType="dark">
            <Button
              className="artist-table__edit"
              icon="pen-to-square"
              colorType="secondary-black"
              containerStyle="link"
            />
          </Tooltip>
        </Link>
      )
    }
  ]

  return (
    <Table
      className="artist-table"
      columns={columns as any}
      rowKey={(record: any) => record.id}
      tableLayout="fixed"
      data={artistListRows}
      pagination={false}
      defaultSort={{
        direction: 'ASC',
        key: 'name'
      }}
    />
  )
}

export default ArtistTable
